import analytics from '~/lib/analytics';
import { findForm } from '~/lib/client';
import Form from '~/pages/forms/components/Submission/Form';

class Submission extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: this.props.form,
    };
  }

  componentDidMount() {
    if (this.props.formID) {
      this.fetchForm(this.props.formID);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.form) {
      this.setState({ form: props.form });
    }
  }

  fetchForm(formID) {
    if (!formID) {
      throw new Error('formID required');
    }

    findForm(formID)
      .then((form) => {
        this.setForm(form);
        this.trackVisit(form);
      })
      .catch(() => {
        alert('Sorry, there was an error fetching this form.');
      });
  }

  setForm(form) {
    analytics.initialize({
      Clearbit: {
        apiKey: form.analytics_key,
      },
    });

    this.setState({ form });
  }

  getThemeClass() {
    return `forms-theme-${this.props.theme || 'default'}`;
  }

  getClassName() {
    const { form } = this.state;

    return classnames('cb-submission', {
      'cb-loading': !form,
      'cb-loaded': !!form,
    });
  }

  trackVisit(form) {
    analytics.track('form_visit', {
      form_id: form.id,
    });
  }

  onResponse(response) {
    const { form } = this.state;
    const { onResponse, onCloseOverlay } = this.props;

    analytics.track('form_submission', {
      form_id: form.id,
      response: response,
    });

    onResponse && onResponse();

    if (onCloseOverlay) {
      setTimeout(onCloseOverlay, 1000);
    }
  }

  renderLoading() {
    return <div className="loading" />;
  }

  renderForm() {
    const { form } = this.state;
    const { email, params } = this.props;

    return (
      <Form
        form={form}
        email={email}
        params={params}
        onResponse={this.onResponse.bind(this)}
      />
    );
  }

  render() {
    const { form } = this.state;

    return (
      <div className={this.getThemeClass()}>
        <div className={this.getClassName()}>
          {form ? this.renderForm() : this.renderLoading()}
        </div>
      </div>
    );
  }
}

Submission.propTypes = {
  form: PropTypes.object,
  theme: PropTypes.string,
  onResponse: PropTypes.func,
  email: PropTypes.string,
  params: PropTypes.object,
};

export default Submission;
